// BDSJEA-447: validación del formulario de campañas (ABM de Administración agro).
// El código es AAAA/AA. El sufijo puede ser el año siguiente (2024/25) o el mismo año
// (2024/24: lo crea la importación de siembras con vigencia 01-01 a 31-12). Misma regla
// que el backend (DominioController.validarCodigoCampana).
import * as Yup from "yup"

export const CODIGO_CAMPANA_REGEX = /^\d{4}\/\d{2}$/

export const MENSAJES_CAMPANA = {
  codigoRequerido: "Código requerido",
  formato: "Formato inválido. Use AAAA/AA (ej: 2025/26 o 2025/25)",
  codigoUnico: "Ya existe una campaña con este código",
  ayuda:
    "Formato AAAA/AA — el sufijo es el año siguiente (2025/26) o el mismo año (2025/25).",
  fechaInexistente: "La fecha no existe en el calendario (use AAAA-MM-DD)",
}

// true si el texto AAAA-MM-DD es una fecha real (rechaza 2024-13-45 y 2024-02-30)
export const esFechaReal = valor => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor || "")
  if (!m) return false
  const [anio, mes, dia] = [Number(m[1]), Number(m[2]), Number(m[3])]
  const d = new Date(Date.UTC(anio, mes - 1, dia))
  return (
    d.getUTCFullYear() === anio &&
    d.getUTCMonth() === mes - 1 &&
    d.getUTCDate() === dia
  )
}

const testFechaReal = value =>
  !value || !/^\d{4}-\d{2}-\d{2}$/.test(value) || esFechaReal(value)

// Devuelve el mensaje de error del código, o null si es válido.
export const validarCodigoCampana = codigo => {
  if (!codigo) return null
  if (!CODIGO_CAMPANA_REGEX.test(codigo)) return MENSAJES_CAMPANA.formato
  const [aaaa, aa] = codigo.split("/")
  const anio = parseInt(aaaa, 10)
  const sufijo = parseInt(aa, 10)
  const mismoAnio = anio % 100
  const anioSiguiente = (anio + 1) % 100
  if (sufijo !== mismoAnio && sufijo !== anioSiguiente) {
    const pad = n => String(n).padStart(2, "0")
    return (
      `El sufijo debe ser el año siguiente (${aaaa}/${pad(anioSiguiente)}) ` +
      `o el mismo año (${aaaa}/${pad(mismoAnio)})`
    )
  }
  return null
}

// BDSJEA-152: activa flag manual
export const getCampanaSchema = (campanas, editando) =>
  Yup.object().shape({
    codigo: Yup.string()
      .required(MENSAJES_CAMPANA.codigoRequerido)
      .test("codigo-campana", function (value) {
        const mensaje = validarCodigoCampana(value)
        return mensaje ? this.createError({ message: mensaje }) : true
      })
      .test("codigo-unico", MENSAJES_CAMPANA.codigoUnico, value => {
        if (!value) return true
        return !campanas.some(c => c.codigo === value && c.id !== editando?.id)
      }),
    fechaInicio: Yup.string()
      .required("Fecha de inicio requerida")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Use el formato AAAA-MM-DD")
      .test("fecha-real", MENSAJES_CAMPANA.fechaInexistente, testFechaReal),
    fechaFin: Yup.string()
      .required("Fecha de fin requerida")
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Use el formato AAAA-MM-DD")
      .test("fecha-real", MENSAJES_CAMPANA.fechaInexistente, testFechaReal)
      .test(
        "fin-no-anterior-inicio",
        "La fecha de fin no puede ser anterior a la de inicio",
        function (value) {
          const { fechaInicio } = this.parent
          if (!fechaInicio || !value) return true
          if (!esFechaReal(fechaInicio) || !esFechaReal(value)) return true
          return value >= fechaInicio
        },
      ),
  })
